import React from 'react';
import { PlusIcon, RotateCcwIcon } from 'lucide-react';
interface ResultActionsProps {
  showAll: boolean;
  onToggleShowAll: () => void;
  onStartOver: () => void;
  onAddPrice: () => void;
  addOpen: boolean;
  radiusMiles: number;
  hiddenCount: number;
}
const buttonClass = 'inline-flex items-center gap-1.5 rounded-lg border border-line bg-surface px-3.5 py-2 text-sm font-medium text-ink-muted transition-colors duration-150 hover:border-ink/25 hover:text-ink';
export function ResultActions({
  showAll,
  onToggleShowAll,
  onStartOver,
  onAddPrice,
  addOpen,
  radiusMiles,
  hiddenCount
}: ResultActionsProps) {
  return <div className="flex flex-wrap items-center gap-2 pt-5" data-id="element-170" data-mp="wbhmovs274qk">
      <button type="button" onClick={onStartOver} className={buttonClass} data-id="element-171" data-mp="rcere31vscvs">
        <RotateCcwIcon className="h-4 w-4" aria-hidden="true" data-id="element-172" data-mp="mcsfbwxsh2ok" />
        Start over
      </button>

      <button type="button" onClick={onToggleShowAll} aria-pressed={showAll} className={showAll ? 'inline-flex items-center gap-1.5 rounded-lg border border-ink bg-ink px-3.5 py-2 text-sm font-medium text-white transition-colors duration-150' : buttonClass} data-id="element-173" data-mp="hdp94962oqf0">
        {showAll ? `Showing all quarries — back to ${radiusMiles} mi` : `Show all${hiddenCount > 0 ? ` (+${hiddenCount} beyond ${radiusMiles} mi)` : ''}`}
      </button>

      <button type="button" onClick={onAddPrice} aria-expanded={addOpen} className="inline-flex items-center gap-1.5 rounded-lg border border-accent bg-accent-soft px-3.5 py-2 text-sm font-medium text-accent transition-colors duration-150 hover:bg-accent hover:text-white" data-id="element-174" data-mp="12vccrqru6cef">
        <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-175" data-mp="xv7txu3gh5l1" />
        Add a price manually
      </button>
    </div>;
}